import {
  PlannedQtyCreateRequest,
  PlannedQtyInputs,
  PlannedQtyUpdateInputs,
  PlannedQtyUpdateRequest,
} from '../../../types/app/plannedQty.types';

export const convertDataFromInputToCreateRequest = (
  data: PlannedQtyInputs,
): PlannedQtyCreateRequest => ({
  assetId: data.assetId,
  qty: data.qty,
  time: data.time,
});

export const convertDataFromInputToUpdateRequest = (
  data: PlannedQtyUpdateInputs,
): PlannedQtyUpdateRequest => ({
  id: data.id,
  assetId: data.assetId,
  qty: data.qty,
  time: data.time,
});
